<template>

    <div class="list-generator-step-1">

        <b-form validated horizontal>

            <b-form-group label="List Title">
                <b-form-input required
                              v-model="docData.listTitle">
                </b-form-input>
            </b-form-group>

            <b-form-group label="Description (optional)">
                <b-form-textarea v-model="docData.listDescription" lines="3">
                </b-form-textarea>
            </b-form-group>

        </b-form>

    </div>

</template>

<script>

import Vue from 'vue'
import ToolMixin from '@/providers/ToolMixin'

export default Vue.extend({
    name: "ListGeneratorStep1",
    mixins: [ToolMixin],
    computed: {
        thisStepIsValid() {
            return this.docData.listTitle
        }
    },
})

</script>
